import { Button, Card, Divider, Modal, Row, Col } from "antd"
import axios from "axios"
import { useState } from "react"
import { useEffect } from "react"
import { useHistory } from "react-router-dom"
// import { CheckCircleOutlined} from '@ant-design/icons'
// import logo from "../Asset/logo-white.png"

const GridGames = () => {
    const history = useHistory()
    const [listOfGame, setListOfGame] = useState([])
    const [ currentGame, setCurrentGame] = useState("")
    const [isModalOpen, setIsModalOpen] = useState(false);

    const showModal = (id) => {
        let game = listOfGame.filter((el) => el.id === id)
        setCurrentGame(game)
        setIsModalOpen(true);
      };
    
      const handleOk = () => {
        setIsModalOpen(false);
      };
    
      const handleCancel = () => {
        setIsModalOpen(false);
      };

      
    const HandleSeeMore = () => {
        history.push("/games")
    }
    const games = async () => {
       const result = await axios.get("https://super-bootcamp-backend.sanbersy.com/api/games")
        .then((res)=> res.data)
        .catch((err) => {
            console.log(err)
        })
        const newListGame = result.slice(0,9)
        setListOfGame(newListGame)
    }

    useEffect(() => {
        games()
    }, [])

    return (
        <div style={{marginTop: "100px"}}>
            <Divider orientation="center" style={{fontSize: "30px"}}>
               GAMES
            </Divider>
            <Card>
               {listOfGame.map((el) =>
               
                    <Card.Grid key={el.id}>
                        <img src={el.image_url} alt="banner-game"></img>
                        <h1>{el.name}</h1>
                        <Button type="primary" onClick={() => showModal(el.id)}>Detail</Button>
                                <Modal title={currentGame[0]?.name} open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={null}>
                                    <div>
                                        <img src={currentGame[0]?.image_url} alt="banner-game" style={{height: "300px"}}></img>
                                        <Row>
                                            <Col className="isi-modal">
                                                <p>{`Genre: ${currentGame[0]?.genre}`}</p>
                                                <p>{`Release: ${currentGame[0]?.release}`}</p>
                                                <p>{`Platform: ${currentGame[0]?.platform}`}</p>
                                                <p>Single Player: {currentGame[0]?.singlePlayer === 0 ? "No" : "Yes"}</p>
                                                <p>Multi Player: {currentGame[0]?.multiPlayer === 0 ? "No" : "Yes"}</p>
                                            </Col>
                                            
                                        </Row>
                                    </div>
                                    
                                </Modal>
                    </Card.Grid>
                )}
                
                <Button style={{margin: "30px auto"}} type="primary" size="large" onClick={HandleSeeMore}>See More</Button>
               
                
            </Card>
        </div>
        
    )
}

export default GridGames